export default {
  'Extract audio': '提取音频',
  'Mute': '静音',
  'Split video and audio': '分离音视频',
}